import { useCallback, useEffect } from "react";
import { useSelector, shallowEqual } from "react-redux";

import * as c from "../../constants";
import { useFeatureFlag } from "../useFeatureFlags";
import {
    selectEntityForTree
} from "../../state/slices/CoreEntity";
import {selectEntityForOrgTree} from "../../state/slices/OrgTree";

export const useEntityCardLogic = (entityID) => {

    const entity = useSelector((state) =>
            selectEntityForTree(entityID)(state) ?? selectEntityForOrgTree(entityID)(state),
        shallowEqual
    );

    // Feature flags
    const hotelIntegrationsName = "Hotel Integrations";
    const hotelIntegrations = useFeatureFlag(hotelIntegrationsName);

    const isDisabledByFeature = useCallback(() => {
        switch (entity?.deviceMode) {
            case c.DEVICE_MODE.HOTEL_INTERFACE:
                return !hotelIntegrations;
        }
        return false;
    }, [entity?.deviceMode, hotelIntegrations]);

    const getDisabledFeatureName = useCallback(() => {
        switch (entity?.deviceMode) {
            case c.DEVICE_MODE.HOTEL_INTERFACE:
                return hotelIntegrations ? "" : hotelIntegrationsName;
        }
        return "";
    }, [entity?.deviceMode, hotelIntegrations]);



    useEffect(() => {
        // Force rerender if user or entity or other stuff in the array changes
        return () => {};
    }, [entity?.laneClosed, entity?.lotFull, entity?.disabled, entityID]);

    return {
        entity,
        isDisabledByFeature,
        getDisabledFeatureName,
    };
}

// Import at the top of the file - moved here to avoid circular dependencies
